module.exports = __webpack_public_path__ + "media/images/flags/4x3/chl-89f44f81275dba40ce6824574a30ee7f.svg";